import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { DireccionSocioSelect } from 'sharedComponents/select'

const DireccionSocioFormGroup = ({ iValue_IdSocio, iError, iTouched, fIsSubmitting, setFieldValue }) => {
  const oneRowTrigger = React.useCallback(
    row => {
      setFieldValue('_idDireccion', row._id)
    },
    [setFieldValue]
  )

  const seleccionarDireccionCreadaHandler = React.useCallback(
    ({ _id }, closeModal, refreshSelect) => {
      refreshSelect().then(() => {
        setFieldValue('_idDireccion', _id)
        closeModal()
      })
    },
    [setFieldValue]
  )

  return (
    <>
      <Form.Group>
        <Form.Label text='PUNTO LLEGADA' htmlFor='select-idDireccion' md={3} alignRightAt='md' />
        <Col md={9}>
          <Form.InputGroup>
            <Field name='_idDireccion'>
              {({ field }) => (
                <DireccionSocioSelect
                  {...field}
                  idSocio={iValue_IdSocio}
                  disabled={fIsSubmitting || iValue_IdSocio === ''}
                  onCreate={seleccionarDireccionCreadaHandler}
                  oneRowTrigger={oneRowTrigger}
                  id='select-idDireccionSocio'
                  showNewButton
                  isInvalid={iTouched && iError}
                />
              )}
            </Field>
            {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
          </Form.InputGroup>
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(DireccionSocioFormGroup)
